// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".noDataBox[data-v-f93e2a48] {\n  width: 100vw;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding-top: 10vw;\n  padding-bottom: 10vw;\n  font-size: 12px;\n  color: rgb(137, 137, 137);\n}\n.noDataBox > img[data-v-f93e2a48] {\n  width: 28vw;\n  height: 28vw;\n}\n.cellCon[data-v-f93e2a48] {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 2.66667vw;\n  padding-bottom: 21.33333vw;\n}", ""]);
// Exports
module.exports = exports;
